import React from 'react';
import { BoxIcon } from 'lucide-react';
interface BenefitCardProps {
  number: number;
  title: string;
  problem: string;
  solution: string;
  impact: string;
  icon: BoxIcon;
  imageSrc: string;
}
export const BenefitCard = ({
  number,
  title,
  problem,
  solution,
  impact,
  icon: Icon,
  imageSrc
}: BenefitCardProps) => {
  return <div className="bg-white rounded-xl shadow-md overflow-hidden mb-12" data-id="element-501">
      <div className="bg-indigo-700 text-white p-4 md:p-5 flex items-center" data-id="element-502">
        <div className="bg-white text-indigo-700 h-10 w-10 rounded-full flex items-center justify-center font-bold text-xl mr-4" data-id="element-503">
          {number}
        </div>
        <h3 className="text-xl font-bold" data-id="element-504">{title}</h3>
      </div>
      <div className="flex flex-col md:flex-row" data-id="element-505">
        <div className="md:w-1/3 h-48 md:h-auto" data-id="element-506">
          <img src={imageSrc} alt={title} className="w-full h-full object-cover" data-id="element-507" />
        </div>
        <div className="p-5 md:p-6 md:w-2/3" data-id="element-508">
          <div className="flex items-start mb-6" data-id="element-509">
            <div className="bg-indigo-100 p-2 rounded-full mr-4 flex-shrink-0" data-id="element-510">
              <Icon className="h-6 w-6 text-indigo-700" data-id="element-511" />
            </div>
            <div data-id="element-512">
              <h4 className="font-semibold text-slate-800 mb-2" data-id="element-513">
                The Challenge
              </h4>
              <p className="text-slate-600" data-id="element-514">{problem}</p>
            </div>
          </div>
          <div className="mb-6" data-id="element-515">
            <h4 className="font-semibold text-slate-800 mb-2" data-id="element-516">
              The NightPhase Solution
            </h4>
            <p className="text-slate-600" data-id="element-517">{solution}</p>
          </div>
          <div className="bg-slate-50 p-4 rounded-lg border-l-4 border-indigo-500" data-id="element-518">
            <h4 className="font-semibold text-slate-800 mb-2" data-id="element-519">Real Impact</h4>
            <p className="text-slate-600 italic" data-id="element-520">{impact}</p>
          </div>
        </div>
      </div>
    </div>;
};